export default __webpack_public_path__ + "static/media/Background_00158.9344e046.png";